import { PointsToOmni } from '@/src/experiences'

export default PointsToOmni.Navigation.Layout
